import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/routing/rootRoute.ts';
import { queryClient } from '@/App.tsx';
import BookingPublicSummaryPage from '@/features/public/bookingSummary/pages/BookingPublicSummaryPage.tsx';
import { getBookingSummaryQueryOptions } from '@/features/public/bookingSummary/hooks/useGetBookingSummary.ts';
import BookingPublicSummarySkeleton from '@/features/public/bookingSummary/components/BookingPublicSummarySkeleton.tsx';

const searchSchema = z.object({
  token: z.string(),
});

export const bookingPublicSummaryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/booking/$orgSlug/summary',
  component: BookingPublicSummaryPage,
  pendingComponent: BookingPublicSummarySkeleton,
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({ token: search.token }),
  loader: async ({ params, deps }) => {
    const { orgSlug } = params;
    const { token } = deps;

    const bookingSummary = await queryClient.ensureQueryData(
      getBookingSummaryQueryOptions(orgSlug, token),
    );

    return { bookingSummary };
  },
});
